<template>
  <PopUpModal ref="popup">
    <div class="m-3">
      <div class="row w-50 img-fluid m-auto">
        <img
          v-bind:src="image"
          class="img-fluid"
          alt="question mark image"
        />
      </div>
      <div class="row bb-hdg mt-3 mb-1 justify-content-center text-center">
        {{ title }}
      </div>
      <div
        class="row bb-sub-hdg mt-3 mb-1 justify-content-center text-center warning-dialog-message"
      >
        {{ message }}
      </div>
      <div
        class="row bb-sub-sub-hdg mt-2 mb-2 justify-content-center text-center"
      >
        {{ subject }}
      </div>
      <!--  text-center -->
      <div
        class="btn-group special mt-4"
        role="group"
      >
        <!-- ------------ -->
        <!--    cancel    -->
        <!-- ------------ -->
        <!-- <button v-if="cancelButton" type="button" @click="_cancel" class="btn btn-lg btn-warning">
          {{ cancelButton }}
        </button> -->
        <!-- ------------ -->
        <!--      OK      -->
        <!-- ------------ -->
        <button
          v-if="okButton"
          type="button"
          @click="_confirm"
          class="btn btn-lg btn-primary"
        >
          {{ okButton }}
        </button>
      </div>
    </div>
  </PopUpModal>
</template>
<script>
import PopUpModal from './PopUpModal.vue'
import defaultImage from '../assets/images/bbExclamationRed.png'

export default {
  name: 'WarningDialog',
  components: {
    PopUpModal,
  },
  data: () => ({
    title: undefined,
    message: undefined,
    subject: undefined,
    okButton: undefined,
    // cancelButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
    image: defaultImage,
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.subject = opts.subject
      this.okButton = opts.okButton
      this.image = opts.image || defaultImage
      // if (opts.cancelButton) {
      //   this.cancelButton = opts.cancelButton
      // }
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(true)
    },

    // _cancel() {
    //   this.$refs.popup.close()
    //   this.resolvePromise(false)
    // },
  },
}
</script>

<style scoped>
.warning-dialog-message {
  white-space: pre-line;
}
</style>
